import { ClientStateRoot } from "./schema";
import { IShopRenterProduct, ShopRenterCategoryInfo, ShopRenterInfo, ShopRenterPageType, ShopRenterProductInfo } from "./schema/shoprenterinfo";

const WINDOW_SHOPRENTER_PROPERTY = 'ShopRenter';

const ROUTE_PREFIX_INFORMATION = 'information/';

const ROUTE_CATEGORY = 'product/list';
const ROUTE_PRODUCT = 'product/product';
const ROUTE_CART = 'cart';
const ROUTE_HOME = '';
const ROUTE_CHECKOUT = 'checkout';
const ROUTE_POSTPURCHASE = 'checkout/success';
const ROUTE_CREATE_ACCOUNT = 'account/success';
const ROUTE_LOGIN = 'customer_login';
const ROUTE_ACCOUNT = 'account/account';

const CHECKOUT_HASH_CUSTOMERDATA = '#/customerdata/';
const CHECKOUT_HASH_SHIPPINGMETHOD = '#/shippingmethod/';
const CHECKOUT_HASH_PAYMENTMETHOD = '#/paymentmethod/';
const CHECKOUT_HASH_CONFIRMATION = '#/confirmation/';


interface IShopRenter {
  product?: Partial<IShopRenterProduct>,
  page?: {
    route?: string
  };
  shop?: {
    locale?: string,
    currency?: {
      code?: string
    };
    name?: string
  };
}

const shopRenterDetected = (window: Partial<Window>) => WINDOW_SHOPRENTER_PROPERTY in window;

const getPageType = (ShopRenter:IShopRenter, windowLocationHash?:string): ShopRenterPageType|undefined => {
  if (ShopRenter?.page?.route?.startsWith(ROUTE_PREFIX_INFORMATION)) {
    return ShopRenterPageType.INFORMATION;
  }
  switch (ShopRenter?.page?.route) {
    case ROUTE_CATEGORY:
      return ShopRenterPageType.CATEGORY;
    case ROUTE_PRODUCT:
      return ShopRenterPageType.PRODUCT;
    case ROUTE_CART:
      return ShopRenterPageType.CART;
    case ROUTE_HOME:
      return ShopRenterPageType.HOME;
    case ROUTE_CHECKOUT:
      switch (windowLocationHash) {
        case CHECKOUT_HASH_CUSTOMERDATA:
          return ShopRenterPageType.CHECKOUT_CUSTOMERDATA;
        case CHECKOUT_HASH_SHIPPINGMETHOD:
          return ShopRenterPageType.CHECKOUT_SHIPPINGMETHOD;
        case CHECKOUT_HASH_PAYMENTMETHOD:
          return ShopRenterPageType.CHECKOUT_PAYMENTMETHOD;
        case CHECKOUT_HASH_CONFIRMATION:
          return ShopRenterPageType.CHECKOUT_CONFIRMATION;
      }
      break;
    case ROUTE_POSTPURCHASE:
      return ShopRenterPageType.POSTPURCHASE;
    case ROUTE_ACCOUNT:
    case ROUTE_CREATE_ACCOUNT:
      return ShopRenterPageType.ACCOUNT;
    case ROUTE_LOGIN:
      return ShopRenterPageType.LOGIN;
  }
};

const getCategoryInfo = (window: Partial<Window>, ShopRenter:IShopRenter): ShopRenterCategoryInfo["category"]|undefined => {

    const pathParts = window?.location?.pathname?.split('/');
    if (pathParts && pathParts.length > 0) {
      return {categoryHandle: pathParts.pop()};
    }
};

const getProductInfo = (ShopRenter: IShopRenter): ShopRenterProductInfo["product"]|undefined => {
  // Test URL: https://kosztovics.shoprenter.hu/pantos-koromcipo-laura-scott-436
  return ShopRenter?.product;
};

export const extendClientStateRoot = (root: ClientStateRoot, window: Partial<Window>): ClientStateRoot => {
  if (shopRenterDetected(window)) {
    let shopRenterInfo: ShopRenterInfo | undefined = undefined;
    const ShopRenter = (window as any)[WINDOW_SHOPRENTER_PROPERTY] as IShopRenter;
    const pageType = getPageType(ShopRenter, window?.location?.hash);
    const shopInfo = {
      locale: ShopRenter?.shop?.locale,
      currency: ShopRenter?.shop?.currency?.code,
      shopId: ShopRenter?.shop?.name
    };
    switch (pageType) {
      case ShopRenterPageType.PRODUCT:
        shopRenterInfo = {
          pageType,
          product: getProductInfo(ShopRenter),
          ...shopInfo
        };
        break;
      case ShopRenterPageType.CATEGORY:
        shopRenterInfo = {
          pageType,
          category: getCategoryInfo(window, ShopRenter),
          ...shopInfo
        };
        break;
      case undefined:
        break;
      default:
        shopRenterInfo = { pageType, ...shopInfo }
    }
    if (shopRenterInfo !== undefined) {
      root.shopRenter = shopRenterInfo;
    }
  }
  return root;
}